module.exports = __webpack_public_path__ + "img/1.23baec87.jpg";